import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function StatusPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/run/${id}`, { replace: true });
  }, [id, navigate]);

  return null;
}
